export const blockIconsCommonactionsScheduleNew = (
	<span className='material-symbols-outlined'>schedule</span>
);
